import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';

@Component({
  selector: 'shared-ui-radio-button-box',
  imports: [ReactiveFormsModule, NgClass],
  templateUrl: './radio-button-box.component.html',
})
export class RadioButtonBoxComponent {
  readonly control = input.required<FormControl>();
  readonly id = input.required<string>();
  readonly name = input.required<string>();
  readonly value = input.required<any>();
  readonly invalid = input<boolean>(false);
}
